import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje } from '../../mensajes';

import { Dimmer } from "../../spinner";

import useTable from "../../useTable";
import Controls from "../../controls/Controls";
import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

;

import axios from 'axios';

const TablaPb = props => {


    let op = require('../../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');

    const btnCancela = useRef();
    const [mostrar, setMostrar] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const [values, setValues] = useState({});
    const [itemSelect, setItemSelect] = useState(-1);
    const [activo, setActivo] = useState(true);


    const headCells = [
        { id: '', label: 'ID', width: '80px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
        { id: '', label: 'DESCRIPCIÓN', width: '600px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
        { id: '', label: 'CODIGO/ORDENANZA', width: '80px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
    ]

    const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idtipopublicidad.toLowerCase().includes(target.value.toLowerCase())
                            || x.descripcion.toLowerCase().includes(target.value.toLowerCase())
                            || x.codigoordenanza.toLowerCase().includes(target.value.toLowerCase())) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    const seleccionarPub = (idtipopublicidad) => {

        let endpoint = `${op.conexion}/api/catalogo/publicidad?idtipopublicidad=${idtipopublicidad}`;

        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                var acti = []
                for (let i = 0; i < response.data.length; i++) {
                    acti.push({
                        idtipopublicidad: response.data[i].idtipopublicidad,
                        descripcion: response.data[i].descripcion,
                        codigoordenanza: response.data[i].codigoordenanza,
                        monto : response.data[i].monto,
                        numerounidad : response.data[i].numerounidad
                    })
                }
                setRecords(acti)
            }

            setActivate(false);

        }).catch(function (error) {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);

        })

    }

    const blanquear = () => {

        setMostrar(false);
        setTitulo('');
        setMsg('');
        setActivate(false);
        setRecords([]);
        setFilterFn({ fn: items => { return items; } });
    }

    const seleccionarPb = (index) => (event) => {

        var valor = { idtipopublicidad: recordsAfterPagingAndSorting()[index].idtipopublicidad, descripcion: recordsAfterPagingAndSorting()[index].descripcion, codigoordenanza: recordsAfterPagingAndSorting()[index].codigoordenanza, monto: recordsAfterPagingAndSorting()[index].monto, numerounidad: recordsAfterPagingAndSorting()[index].numerounidad }

        blanquear();
        props.onHideAceptaCatPb(valor);


    };

    const handleCloseMensa = () => {
        setMostrar(false);
    }

    const cancelar = () => {

        blanquear();
        props.onHideCloseCatag();
    }

    const seleccionarFila = (index) => (event) => {

        setItemSelect(index);
        setActivo(false);

        var item = recordsAfterPagingAndSorting()[index];


        setValues(item);
    };

    const seleccionarLista = (index) => (event) => {


        blanquear();
        props.onHideAceptaCatPb(values);
    
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{backgroundColor:"rgb(0,0,0,0.3)"}}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                seleccionarPub();
            }}
        >
            <Modal.Header className='azulGradiant' style={{ height: '40px' }}>
                <div style={{ color: "#fff",  fontSize: 20 }}>Seleccionar Clasificador de Publicidad.</div>
            </Modal.Header>
            <Modal.Body>
                <Mensaje titulo={titulo} mensaje={msg}
                    show={mostrar}
                    onHide={handleCloseMensa} />
                <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className="col-md-12 m-0">

<div className="input-group input-group-sm mb-3 m-0 col-md-5">
    <input type='text'
        onChange={handleSearch} className="form-control rounded-pill search-input " />
</div>
</div>
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer >
                        <TblHead />

                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={item.idtipopublicidad} style={{ padding: "0", cursor: 'pointer', background: values.idtipopublicidad === item.idtipopublicidad ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)}>
                                        <td style={{ fontSize: "10px", textAlign: "center", width: "50px", verticalAlign: "middle" }}>{item.idtipopublicidad}</td>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "600px", verticalAlign: "middle" }}>{item.descripcion}</td>
                                        <td style={{ fontSize: "10px", textAlign: "center", width: "40px", verticalAlign: "middle" }}>{item.codigoordenanza}</td>
                                       {/*  <td align="center" style={{ fontSize: "10px", textAlign: "center", width: "140px", padding: 0, verticalAlign: "middle" }}>
                                            <button style={{ width: "120px" }} onClick={seleccionarPb(index)} className="btn btn-info btn-sm rounded-pill"><i className="fas fa-edit"> Seleccionar </i> </button>
                                        </td> */}
                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer>
            <button className="btn btn-sm btn-success rounded-pill" disabled={activo} onClick={seleccionarLista()}><i className="fas fa-check-circle"> Aceptar</i> </button>

                <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill"><i className="fa"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default TablaPb;